"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React from "react"
import Link from "next/link"
import styles from "../TherapistsPage.module.css"
import { useScrollAnimations } from "../../../hooks/useScrollAnimations"

// Reusable styles
const gradientBackground = {
  background:
    "linear-gradient(19deg, rgba(228, 255, 63, 0.70) -108.49%, rgba(0, 178, 255, 0.70) 68.69%)",
}

const pricingSectionBackground = {
  background:
    "linear-gradient(105deg, rgba(217, 217, 217, 0.30) -9.41%, rgba(37, 99, 235, 0.50) 134.98%)",
}

const priceStyle = {
  fontSize: "2.5rem",
  fontWeight: "bold",
  color: "#00b2ff",
  marginBottom: "0.5rem",
}

const buttonPrimaryStyle = {
  width: "100%",
  marginBottom: "1rem",
}

const buttonSecondaryStyle = {
  width: "100%",
  background: "transparent",
  color: "#00b2ff",
  border: "2px solid #00b2ff",
}

// Feature data
const basicFeatures = [
  "List 1 group",
  // "Manage up to 12 clients",
  "Client interest form",
  // "Group portal for clients",
  // "Send group announcements",
  // "Automated email session reminders",
  // "Secure payments",
  // "Secure messaging",
  "Standard search placement",
  "1 professional provider profile",
  "Store meeting reflections",
]

// Reusable FeatureItem component
const FeatureItem = ({ children }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      marginBottom: "1rem",
    }}
  >
    <span
      style={{
        color: "#22c55e",
        marginRight: "1rem",
        fontWeight: "bold",
      }}
    >
      ✓
    </span>
    <span>{children}</span>
  </div>
)

export default function PricingSection() {
  useScrollAnimations(styles, styles.featureCard)

  return [
    <section
      key="pricing-section"
      className={styles.pricingSection}
      style={pricingSectionBackground}
      id="pricing"
    >
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>Start For Free</h2>

        <div style={{ maxWidth: "600px", margin: "0 auto" }}>
          <div className={`${styles.card} ${styles.cardElevated}`}>
            <h3 className={styles.h3} style={{ marginBottom: "0.5rem" }}>
              Basic
            </h3>
            <div style={priceStyle}>Free</div>
            <p className={styles.textMedium} style={{ marginBottom: " 3rem" }}>
              Get listed and explore the essentials to group work operations
            </p>

            <div style={{ textAlign: "left", marginBottom: "3rem" }}>
              {basicFeatures.map((feature, index) => (
                <FeatureItem key={index}>{feature}</FeatureItem>
              ))}
            </div>

            <Link
              href="/signup"
              className={`${styles.btn} ${styles.btnGradientPrimary}`}
              style={buttonPrimaryStyle}
            >
              Start Free
            </Link>
            <Link
              href="/pricing"
              className={`${styles.btn} ${styles.btnSecondary}`}
              style={buttonSecondaryStyle}
            >
              View All Plans
            </Link>
          </div>
        </div>

        <div className={"text-center"} style={{ marginTop: "3rem" }}>
          <p className={"text-[#666]"}>
            Join the community helping group work flourish with ZestLife.
          </p>
        </div>
      </div>
    </section>,
    <section key="cta-section" style={{ padding: "4rem 0", ...gradientBackground }}>
      <div className={styles.container}>
        <div className={styles.ctaSection} style={{ margin: 0 }}>
          <h3>Expand Your Professional Reach Today</h3>
          <p>
            Talk to a member of our team to answer your questions or get help getting
            set up.
          </p>
          <div className={styles.ctaButtonsInline}>
            <a
              href="mailto:providers@getzestlife.com"
              className={styles.btnCtaPrimary}
            >
              Book a consultation{" "}
            </a>
          </div>
        </div>
      </div>
    </section>,
  ]
}
